"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.auth = void 0;

var _common = require("../common");

var _env = require("../env");

var _httpRequest = _interopRequireDefault(require("../httpRequest"));

var _IGC_JS2Native = require("../IGC_JS2Native");

require("url-search-params-polyfill");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var UNION_ID = '_igc_wx_unionId_';
var OPEN_ID = '_igc_wx_openId_';
var NICK_NAME = '_igc_wx_nickName_';
var HEAD_IMG_URL = '_igc_wx_headImgUrl_'; // 授权重试次数 key

var AUTH_RETRY = '_igc_wx_auth_retry_'; // 授权最大重试次数

var MAX_RETRY = 3;
/**
 * @example:
 *
 * auth.config({
 *   appId: process.env.VUE_APP_ID,
 *   passgoServer: process.env.VUE_APP_PASSGO_SERVER,
 * }).doAuth().then(res => {
 *   const { openId, unionId } = res;
 * })
 *
 */

var auth = {
  /**
   * 后端设定渠道类型： 1 qq, 2 微信, 3 小程序，其他类型暂无
   */
  _channel: -1,

  /**
   * 微信授权相关的配置项
   */
  _configs: {
    // 微信公众号 id
    appId: '',
    // passgo 服务器地址
    passgoServer: '',
    // 是否走老微信授权，默认为true
    needPassgo: true
  },

  /**
   * 设置配置项
   * @param {Object} options
   * @options {string} appId 服务号 appid
   * @options {string} passgoServer passgo 地址
   * @options {number=} retry 授权失败重试次数，默认 3 次
   * @options {boolean=} needPassgo 是否需要走 passgo 授权。默认 true
   */
  config: function config(options) {
    var appId = options.appId,
        passgoServer = options.passgoServer,
        _options$retry = options.retry,
        retry = _options$retry === void 0 ? MAX_RETRY : _options$retry,
        _options$needPassgo = options.needPassgo,
        needPassgo = _options$needPassgo === void 0 ? true : _options$needPassgo;

    if (appId) {
      this._configs.appId = appId;
    }

    if (passgoServer) {
      this._configs.passgoServer = passgoServer;
    }

    this._configs.retry = retry;
    this._configs.needPassgo = needPassgo;
    return this;
  },

  /**
   * 调用授权
   * @param {Object=} options
   * @options {string=} options.scope 微信授权模式，默认显式授权 snsapi_userinfo；隐式授权：snsapi_base
   * @example:
   *  调用授权，回调参数中包含 openid 及 unionid
   *  doAuth(options).then(data => {
   *    const { openid, unionid } = data;
   *  })
   * @returns {Promise<any>}
   */
  doAuth: function doAuth() {
    var _this = this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // 默认显示授权
    options = _objectSpread(_objectSpread({}, {
      scope: 'snsapi_userinfo'
    }), options);
    var _this$_configs = this._configs,
        appId = _this$_configs.appId,
        needPassgo = _this$_configs.needPassgo;
    return new Promise(function (resolve) {
      var searchParams = new URLSearchParams(location.search); // 大得到的 token

      var token = searchParams.get('token'); // 微信的 code

      var code = searchParams.get('code');
      var urlOpenid = searchParams.get('openid');

      var unionid = _this._getUnionId(appId);

      var openid = _this._getOpenId(appId);

      var nickname = _this._getNickName(appId);

      var headimgurl = _this._getHeadImgurl(appId);

      if (_env.env.isWeChat) {
        _this._channel = 2; // 如果显式授权。判断是否存在 unionid 和 openid；如果为隐式授权则仅判断 openid 是否存在。

        if (options.scope === 'snsapi_userinfo' && unionid && openid) {
          // 显式
          resolve({
            openid: openid,
            unionid: unionid,
            nickname: nickname,
            headimgurl: headimgurl
          });
        } else if (options.scope !== 'snsapi_userinfo' && openid) {
          resolve({
            openid: openid
          });
        } else if (token || code) {
          // 显示授权时，需要 token 换用户信息
          _this._doLogin(token || code).then(function (res) {
            // unionId
            if (res) {
              resolve(res);
            } else {
              resolve();
            }
          });
        } else if (urlOpenid) {
          // 隐式授权时，openid 直接在 url，直接存起来
          _this._setOpenId(urlOpenid);

          resolve({
            openid: urlOpenid
          });
        } else {
          if (needPassgo) {
            _this._switchPassgo().then(function (passgo) {
              if (passgo) {
                _this._redirectDDAuth(options);
              } else {
                _this._redirectWXAuth(options);
              }
            });
          } else {
            _this._redirectWXAuth(options);
          }
        }
      } else if (_env.env.isQQ) {
        _this._channel = 1;

        if (unionid) {
          resolve({
            unionid: unionid
          });
        } else if (code) {
          _this._doLogin(code).then(function (res) {
            // unionId
            if (res) {
              resolve(res);
            } else {
              resolve();
            }
          });
        } else {
          _this._redirectQQAuth();
        }
      } else if (_env.env.isApp) {
        // 在 App 内不走授权逻辑，这里直接 resolve 用户 pid
        _this._channel = 0;
        (0, _IGC_JS2Native.getAppUserPid)().then(function (_ref) {
          var data = _ref.data;
          resolve({
            userid: data
          });
        });
      } else {
        _this._channel = 4;
        resolve();
      }
    });
  },
  // 如果校验 unionid 失效，走这个方法清空本地 unionid 重新授权获取 unionid。
  redoAuth: function redoAuth() {
    var _this2 = this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var appId = this._configs.appId;
    this.cleanUnionId(appId);
    this.cleanOpenId(appId); // TODO: 需要清除 nickname 和 headimgurl，不清除不影响逻辑

    options = _objectSpread(_objectSpread({}, {
      scope: 'snsapi_userinfo'
    }), options); // location.href = this._getCurrentHref();

    if (this._configs.needPassgo) {
      this._switchPassgo().then(function (passgo) {
        if (passgo) {
          _this2._redirectDDAuth(options);
        } else {
          _this2._redirectWXAuth(options);
        }
      });
    } else {
      this._redirectWXAuth(options);
    }
  },
  cleanUnionId: function cleanUnionId() {
    var appId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    localStorage.removeItem("".concat(UNION_ID).concat(appId));
  },
  _getUnionId: function _getUnionId() {
    var appId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return localStorage.getItem("".concat(UNION_ID).concat(appId));
  },
  _setUnionId: function _setUnionId(id) {
    var appId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    localStorage.setItem("".concat(UNION_ID).concat(appId), id);
  },
  cleanOpenId: function cleanOpenId() {
    var appId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    localStorage.removeItem("".concat(OPEN_ID).concat(appId));
  },
  _getOpenId: function _getOpenId() {
    var appId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return localStorage.getItem("".concat(OPEN_ID).concat(appId));
  },
  _setOpenId: function _setOpenId(id) {
    var appId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    localStorage.setItem("".concat(OPEN_ID).concat(appId), id);
  },
  _setNickName: function _setNickName(nickname) {
    var appId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    localStorage.setItem("".concat(NICK_NAME).concat(appId), nickname);
  },
  _getNickName: function _getNickName() {
    var appId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return localStorage.getItem("".concat(NICK_NAME).concat(appId));
  },
  _setHeadImgurl: function _setHeadImgurl(headimgurl) {
    var appId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    localStorage.setItem("".concat(HEAD_IMG_URL).concat(appId), headimgurl);
  },
  _getHeadImgurl: function _getHeadImgurl() {
    var appId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return localStorage.getItem("".concat(HEAD_IMG_URL).concat(appId));
  },
  _setRetryTime: function _setRetryTime(val) {
    localStorage.setItem(AUTH_RETRY, val);
  },
  _getRetryTime: function _getRetryTime() {
    var t = localStorage.getItem(AUTH_RETRY);
    return t || 0;
  },
  _doLogin: function _doLogin(code) {
    var _this3 = this;

    var _this$_configs2 = this._configs,
        needPassgo = _this$_configs2.needPassgo,
        appId = _this$_configs2.appId; // TODO:线上用

    var requestUrl = needPassgo ? '/app-api-user-server/white/authentication/web/login.json' : '/growth-server/thirdpart/wechat/mp/user/infoByCode'; // TODO:本地
    // let requestUrl = needPassgo ? '/app-api-user-server/white/authentication/web/login.json' :
    // 'http://192.168.1.223:8700/thirdpart/wechat/mp/user/infoByCode' this._channel // 1 qq, 2 微信, 3 小程序

    var requestParams = needPassgo ? {
      code: code,
      channel: this._channel
    } : {
      code: code
    }; // 该接口域名为 igetcool-share.igetcool.com

    return _httpRequest["default"].request(requestUrl, requestParams).then(function (res) {
      var code = res.code,
          data = res.data;

      if (code === 10000) {
        var _res = {}; // 如果是微信环境，data 为 json，包含 openid 及 unionid。如果是其他环境 data 为 number, 返回 unionid

        if (_this3._channel === 2) {
          var openid = data.openid,
              unionid = data.unionid,
              nickname = data.nickname,
              headimgurl = data.headimgurl;

          _this3._setUnionId(unionid, appId);

          _this3._setOpenId(openid, appId);

          _this3._setNickName(nickname, appId);

          _this3._setHeadImgurl(headimgurl, appId);

          _res = {
            openid: openid,
            unionid: unionid,
            nickname: nickname,
            headimgurl: headimgurl
          };
        } else {
          _this3._setUnionId(data, appId);

          _res = {
            unionid: data
          };
        }

        _this3._setRetryTime(0);

        return _res;
      } else {
        var t = _this3._getRetryTime();

        if (++t > _this3._configs.retry) {
          // 重置一下重试次数，否则会一直卡死在这里
          _this3._setRetryTime(0);

          return;
        } else {
          _this3._setRetryTime(t); // 登陆失败，去掉当前 url 中的 code，重新请求 code
          // FIXME: 优化点 - 直接跳转至中间页获取 code，而不是跳转回原页面


          location.href = _this3._getCurrentHref();
        }
      }
    });
  },
  _redirectQQAuth: function _redirectQQAuth() {
    var uri = this._getQQMiddleRedirectUrl();

    this._jumpTo({
      url: 'https://graph.qq.com/oauth2.0/authorize',
      data: {
        response_type: 'code',
        client_id: '101481715',
        redirect_uri: uri,
        state: 'state'
      }
    });
  },

  /**
   * 进行微信原生授权跳转
   * @private
   */
  _redirectWXAuth: function _redirectWXAuth(options) {
    var _this$_configs3 = this._configs,
        appId = _this$_configs3.appId,
        needPassgo = _this$_configs3.needPassgo;

    if (appId) {
      // TODO: 线上用
      var newUrl = "".concat(location.origin, "/growth-server/thirdpart/wechat/mp/user/codeAndRedirect?scope=").concat(options.scope, "&appId=").concat(appId, "&redirectUrl=").concat(encodeURIComponent(this._getCurrentHref()), "&state=STATE"); // TODO:本地
      // let newUrl =
      // `http://test2-3.igetcool.com/growth-server/thirdpart/wechat/mp/user/codeAndRedirect?scope=${options.scope}&appId=${appId}&redirectUrl=${encodeURIComponent(this._getCurrentHref())}&state=STATE`

      this._jumpTo({
        url: 'https://open.weixin.qq.com/connect/oauth2/authorize',
        data: {
          appid: appId,
          redirect_uri: needPassgo ? this._getCurrentHref() : newUrl,
          response_type: 'code',
          scope: options.scope,
          state: 'STATE'
        },
        hash: '#wechat_redirect'
      });
    } else {
      throw new Error('请先通过 config() 方法配置服务号的 appId！');
    }
  },

  /**
   * 大得到的授权跳转
   * DOC: http://openapi.foundation.dev.didatrip.com/swagger-ui/?urls.primaryName=oauth#/h5/wechat_authorize
   * 具体逻辑可以联系大得到：郭云雷
   * @private
   */
  _redirectDDAuth: function _redirectDDAuth(options) {
    var passgoServer = this._configs.passgoServer;
    var scope = options.scope,
        onlyOpenId = options.onlyOpenId;
    var data = {
      sys_code: 8,
      // passgo 平台代码，4得到, 8小得到
      scope: scope === 'snsapi_userinfo' ? 2 : 1,
      // 是否静默授权，1静默，2非静默，默认静默, 微信专用
      origin_url: this._getCurrentHref()
    };

    if (scope !== 'snsapi_userinfo') {
      // 是否仅获取openid, 0：为默认获取用户信息；1：明文获取；2：jwt加密
      data.only_openid = (0, _common.isNil)(onlyOpenId) ? 1 : onlyOpenId;
    }

    if (passgoServer) {
      this._jumpTo({
        url: passgoServer + '/v5/oauth2/authorize/wx',
        data: data
      });
    } else {
      throw new Error('请先通过 config() 方法配置 passgoServer 地址！');
    }
  },

  /**
   * 判断是否要走大得到的 passgo 授权
   * 这个仅限于微信的授权
   * @returns {Promise<any>}
   * @private
   */
  _switchPassgo: function _switchPassgo() {
    return _httpRequest["default"].request('/app-api-common-server/white/passgo/switch.json', {}).then(function (res) {
      var code = res.code,
          data = res.data;

      if (code === 10000) {
        return data.passgoSwitch;
      } else {
        return false;
      }
    });
  },

  /**
   * url 跳转，会 encode query 参数
   * @param {Object} params
   * @private
   */
  _jumpTo: function _jumpTo(params) {
    var url = params.url,
        data = params.data,
        _params$hash = params.hash,
        hash = _params$hash === void 0 ? '' : _params$hash;
    var arr = [];

    for (var key in data) {
      arr.push(key + '=' + encodeURIComponent(data[key]));
    }

    location.href = url + '?' + arr.join('&') + hash;
  },
  _getCurrentHref: function _getCurrentHref() {
    return location.origin + location.pathname + '?' + this._getPureQuery();
  },

  /**
   * '/weblogin' 是配置在 QQ 上的授权路径，QQ 只识别这个路径并通过 target 参数跳转回该页面。
   * 因此这里需要跳转至 /weblogin 路由。该路由在 nginx 中配置
   * @returns {string}
   * @private
   */
  _getQQMiddleRedirectUrl: function _getQQMiddleRedirectUrl() {
    var pathname = location.pathname;

    if (pathname.indexOf('/') === 0) {
      pathname = pathname.substring(1);
    }

    return location.origin + '/weblogin?target=' + pathname + '&' + this._getPureQuery();
  },
  _getPureQuery: function _getPureQuery() {
    var searchParams = new URLSearchParams(location.search);
    var rmKeys = ['from', 'response_type', 'scope', 'state', 'pass_through', 'code', 'token', 'openid'];
    var i = -1;

    while (++i < rmKeys.length) {
      searchParams["delete"](rmKeys[i]);
    }

    return searchParams.toString();
  }
};
exports.auth = auth;